/* Wondaween 2026 — global behaviours (no dependencies) */
(function () {
  'use strict';

  /* Front / back toggles on product cards and the PDP gallery */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-view-toggle]');
    if (!btn) return;
    e.preventDefault();
    var scope = btn.closest('[data-view-scope]');
    if (!scope) return;
    var view = btn.getAttribute('data-view-toggle');
    scope.querySelectorAll('[data-view-toggle]').forEach(function (b) {
      b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
    });
    scope.classList.toggle('show-back', view === 'back');
    scope.querySelectorAll('[data-gallery-slide]').forEach(function (s) {
      s.hidden = s.getAttribute('data-gallery-slide') !== view;
    });
  });

  /* Mobile nav */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-nav-toggle]');
    if (!t) return;
    var header = t.closest('.header');
    var open = header.classList.toggle('is-open');
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.classList.toggle('nav-open', open);
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.header__nav a')) return;
    var header = e.target.closest('.header');
    if (header && header.classList.contains('is-open')) {
      header.classList.remove('is-open');
      document.body.classList.remove('nav-open');
      var t = header.querySelector('[data-nav-toggle]');
      if (t) t.setAttribute('aria-expanded', 'false');
    }
  });

  /* Quantity steppers */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-step]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    var step = parseInt(b.getAttribute('data-qty-step'), 10) || 1;
    var min = parseInt(input.min, 10) || 1;
    var next = Math.max(min, (parseInt(input.value, 10) || min) + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Easter egg: "tap to spin" */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-spin-trigger]');
    if (!t) return;
    var target = document.querySelector('[data-spin-target]');
    if (!target) return;
    target.classList.remove('is-spinning');
    void target.offsetWidth;
    target.classList.add('is-spinning');
  });

  /* Sticky header shadow */
  var header = document.querySelector('.header--sticky');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();
